module.exports = __webpack_public_path__ + "img/shape-9.bdb9b0f7.svg";